import { render } from "./create_testplan.vue?vue&type=template&id=0af0dae3"
import script from "./create_testplan.vue?vue&type=script&lang=js"
export * from "./create_testplan.vue?vue&type=script&lang=js"

import "./create_testplan.vue?vue&type=style&index=0&id=0af0dae3&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__